<template>
    <el-container>
        <el-header class="alarm-device-classify-head">
            <el-row :gutter="20" style="margin-left:0px;padding-top:10px;">
                <p>{{ $t('pgCommon.JOB_STORAGE') }}</p>
            </el-row>
        </el-header>
        <el-main>
            <el-form :model="formInfo" ref="formInfo" label-position="right" :label-width="formLabelWidth">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('common.STORAGE_POLICE_ABLE')" ref="status">
                            <td-radio v-model="isAble" :options="isAbleOptions"></td-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('common.STORAGE_DAY')" :labelWidth="formLabelWidth">
                            <td-inputNumber v-model="formInfo.timeValue" :min="1" :max="365"></td-inputNumber>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <td-button type="primary" :loading="saveLoading" @click="submit('formInfo')">{{ $t('common.SAVE') }}</td-button>
        </el-main>
    </el-container>
</template>

<script>
import resourceApi from './assets/api.js';
export default {
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.getStoragePolicy(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            groupFlg: '',
            groupElementValue: '',
            storagePolicyOptions: [],
            isAbleOptions: [{ value: false, label: this.$t('common.NOT') }, { value: true, label: this.$t('common.YES') }],
            storagePolicyType: 1,
            isAble: false,
            sId: '',
            saveLoading: false,
            formInfo: { timeValue: 1 },
            formLabelWidth: '15%',
            timeShow: true
        };
    },
    // 方法的实现
    methods: {
        // 查询数据
        getStoragePolicy() {
            this.sId = '';
            let content = {
                iType: this.storagePolicyType
            };
            resourceApi.getJobLogStoragePolicy(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('getJobLogStoragePolicy', response.data.statusMessage);
                    return;
                }
                //初始化
                this.formInfo.timeValue = 1;
                let storagePolicy = response.data.content[0];
                if (storagePolicy) {
                    this.isAble = storagePolicy.iTimeStatus !== 0;
                    this.formInfo.timeValue = storagePolicy.iTimeValue;
                    this.sId = storagePolicy.sId;
                }
            });
        },
        // 提交数据
        submit() {
            this.saveLoading = true;
            let content = {
                iType: this.storagePolicyType,
                iTimeValue: this.formInfo.timeValue,
                iTimeStatus: this.isAble ? '1' : '0',
                sId: this.sId
            };
            resourceApi.saveJobLogStoragePolicy(JSON.stringify(content), response => {
                this.saveLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('saveJobLogStoragePolicy', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.SAVE_SUCCESS'), type: 'success' });
            });
        }
    }
};
</script>
